export type UiComponentProps = {
	classNames?: string[];
};

export class UiComponent<T extends UiComponentProps = UiComponentProps> {
	constructor(protected props: T = {} as T) {}

	render(): HTMLElement | DocumentFragment {
		return document.createDocumentFragment();
	}

	getClassNames(): string[] {
		return this.props?.classNames ?? [];
	}
}
